import { render, staticRenderFns } from "./GroupMemberModal.vue?vue&type=template&id=49c565de&scoped=true&"
import script from "./GroupMemberModal.vue?vue&type=script&lang=js&"
export * from "./GroupMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberModal.vue?vue&type=style&index=0&id=49c565de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c565de",
  null
  
)

export default component.exports